import React, { useState } from "react";
import { ThreeDots } from "react-loader-spinner";
import { Link } from "react-router-dom";
import { toggleMenu } from "../../utils/helpers";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { formatToDateOnly } from "../../utils/helpers";
import {
  API_PROJECT,
  API_LEAVE_GET_OOD_DL_LIST,
  API_GET_PRINCIPAL_SPONSOR_LIST,
  API_GET_PROJECT_MANAGER_LIST,
  API_GET_LEAD_BUSINESS_ANALYST_LIST,
  API_GET_HEAD_OF_DELIVERY_LIST,
  API_GET_PROGRAM_MANAGER_LIST,
  API_SQE_PROJECT_LEAD_MEMBERS,
  EMPLOYEE_LIST,
} from "../../config/Endpoints";
import { useNavigate } from "react-router-dom";
import "../../Styles/style.css";
import { getApi } from "../../utils/api";
import { useEffect } from "react";
import axios from "axios";
import CharLimitTextArea from "../../components/Performance/CharLimitTextArea";
import { projectTypeOptions } from "../../options/projectTypesOptions";
import { capitalizeWords } from "../../v2/utils/helpers.ts";
import { FiFileText, FiGlobe, FiInfo, FiTarget, FiUsers, FiX } from "react-icons/fi";
import { useSqeLabs } from "../../v2/hooks/use-sqe-labs.ts";
import { useSqeEmployeeNameOptions } from "../../v2/hooks/use-sqe-employee-name-options.ts";
import { getSqeProjectLeadOptions } from "./sqeProjectLeadOptions";

const needsApprovalOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

const trackableOptions = [
  { value: true, label: "Yes" },
  { value: false, label: "No" },
];

const projectModeCards = [
  {
    value: "ASSIGNED_ONLY",
    title: "Project-Specific",
    description: "Create a dedicated client or internal project with its own team, roles, allocations, goals, and timeline.",
    icon: FiTarget,
  },
  {
    value: "DEPARTMENT",
    title: "Department-Specific",
    description: "Create a controlled-access project. Only employees you explicitly add can record time, even across departments.",
    icon: FiUsers,
  },
  {
    value: "GLOBAL",
    title: "Global Project",
    description: "Create an organisation-wide project that every eligible employee can use for shared activities.",
    icon: FiGlobe,
  },
];

function ProjectModeModal({ show, value, onChange, onCancel, onContinue, isSqeLabs }) {
  if (!show) return null;
  const availableCards = isSqeLabs
    ? projectModeCards.filter((option) => option.value !== "GLOBAL")
    : projectModeCards;

  return (
    <div className="project-mode-backdrop" role="presentation">
      <section className="project-mode-modal" role="dialog" aria-modal="true" aria-labelledby="project-mode-title">
        <header className="project-mode-modal__header">
          <div>
            <h2 id="project-mode-title">Create New Project</h2>
            <p>Choose the project type that matches the access and setup you need.</p>
          </div>
          <button type="button" className="project-mode-modal__close" onClick={onCancel} aria-label="Close">
            <FiX />
          </button>
        </header>
        <div className="project-mode-modal__body">
          <p className="project-mode-modal__prompt">Select a project category to continue.</p>
          <div className="project-mode-grid" role="radiogroup" aria-label="Project type">
            {availableCards.map((option) => {
              const Icon = option.icon;
              const selected = value === option.value;
              return (
                <button
                  key={option.value}
                  type="button"
                  role="radio"
                  aria-checked={selected}
                  className={`project-mode-card${selected ? " project-mode-card--active" : ""}`}
                  onClick={() => onChange(option.value)}
                >
                  <span className={`project-mode-card__icon project-mode-card__icon--${option.value.toLowerCase()}`}>
                    <Icon />
                  </span>
                  <span className="project-mode-card__title">{option.title}</span>
                  <span className="project-mode-card__description">{option.description}</span>
                </button>
              );
            })}
          </div>
        </div>
        <footer className="project-mode-modal__footer">
          <button type="button" className="project-mode-cancel" onClick={onCancel}>Cancel</button>
          <button type="button" className="project-mode-continue" onClick={onContinue}>Continue</button>
        </footer>
      </section>
    </div>
  );
}

function SelectedProjectMode({ value, onChange }) {
  const option = projectModeCards.find((item) => item.value === value) || projectModeCards[0];
  const Icon = option.icon;
  return (
    <div className="selected-project-mode">
      <span className={`project-mode-card__icon project-mode-card__icon--${option.value.toLowerCase()}`}>
        <Icon />
      </span>
      <div className="selected-project-mode__content">
        <span className="selected-project-mode__eyebrow">Project type</span>
        <strong>{option.title}</strong>
        <span>{option.description}</span>
      </div>
      <button type="button" onClick={onChange}>Change type</button>
    </div>
  );
}

const SELECT_PROPS = {
  className: "custom-select",
  classNamePrefix: "react-select",
};

const preventManualDateInput = (e) => {
  if (e.key !== "Backspace" && e.key !== "Delete") {
    e.preventDefault();
  }
};

function FormFieldRow({ id, label, required = false, align = "center", children }) {
  return (
    <div
      className={`cp-field${align === "start" ? " cp-field--start" : ""}`}
    >
      <div className="cp-label">
        <label htmlFor={id} className={required ? "has-asterisk" : undefined}>
          {label}
        </label>
      </div>
      <div className="cp-control">{children}</div>
    </div>
  );
}

function SqeMemberField({ isSqeLabs, options, inputId, children }) {
  if (isSqeLabs && options.length === 1) {
    return (
      <input
        id={inputId}
        type="text"
        className="form-control"
        value={options[0].label}
        readOnly
      />
    );
  }

  return children;
}

function FormDescriptionField({ children }) {
  return (
    <div className="cp-description">
      <label
        htmlFor="commercialSummary"
        className="has-asterisk cp-description-label"
      >
        Project Description
      </label>
      <div className="input-group cp-description-control">{children}</div>
    </div>
  );
}

function DateRangeInputs({
  startDate,
  endDate,
  onStartChange,
  onEndChange,
  startRequired = false,
  endMinDate,
  startMaxDate,
}) {
  return (
    <div className="cp-dates">
      <div className="cp-date">
        <span className="cp-date-badge">Start Date</span>
        <DatePicker
          showIcon
          toggleCalendarOnIconClick
          placeholderText="mm/dd/yyyy"
          selected={startDate}
          onChange={onStartChange}
          className="border custom-date"
          required={startRequired}
          maxDate={startMaxDate}
          onKeyDown={preventManualDateInput}
        />
      </div>
      <div className="cp-date">
        <span className="cp-date-badge">End Date</span>
        <DatePicker
          showIcon
          toggleCalendarOnIconClick
          placeholderText="mm/dd/yyyy"
          selected={endDate}
          onChange={onEndChange}
          className="border custom-date"
          minDate={endMinDate}
          onKeyDown={preventManualDateInput}
        />
      </div>
    </div>
  );
}

const CreateProject = ({ title, description }) => {
  const navigate = useNavigate();
  const isSqeLabs = useSqeLabs();
  const [showProjectModeModal, setShowProjectModeModal] = useState(true);
  const [hasChosenProjectMode, setHasChosenProjectMode] = useState(false);
  const [pendingProjectMode, setPendingProjectMode] = useState("ASSIGNED_ONLY");
  const [isLoading, setIsLoading] = useState(false);
  const [deliveryLead, setDeliveryLead] = useState([]);
  const [principalSponsors, setPrincipalSponsors] = useState([]);
  const [projectManagers, setProjectManagers] = useState([]);
  const [programManagers, setProgramManagers] = useState([]);
  const { options: sqeEmployees } = useSqeEmployeeNameOptions(isSqeLabs);
  const selectableProjectManagers = isSqeLabs
    ? sqeEmployees.map((employee) => ({ value: Number(employee.value), label: employee.label }))
    : projectManagers;
  const [employeeList, setEmployeeList] = useState([]);
  const accessToken = Cookies.get("accessToken");
  const [leadBusinessAnalysts, setLeadBusinessAnalysts] = useState([]);
  const [headOfDeliveryList, setHeadOfDeliveryList] = useState([]);
  const [formData, setFormData] = useState({
    projectName: "",
    projectType: "",
    dlId: "",
    dlName: "",
    startDate: "",
    endDate: "",
    sowStartDate: "",
    sowEndDate: "",
    commercialSummary: "",
    projectManager: "",
    programManager: "",
    principalSponsor: "",
    leadBusinessAnalyst: "",
    headOfDelivery: "",
    needsApproval: false,
    trackable: false,
    timesheetAccessMode: "ASSIGNED_ONLY",
    workstreams: [],
  });

  useEffect(() => {
    const fetchProgramManagers = async () => {
      try {
        const response = await getApi(
          API_GET_PROGRAM_MANAGER_LIST,
          accessToken,
        );
        const managers = (response.data?.data || []).map((pm) => ({
          value: pm.id,
          label: `${pm.firstName} ${pm.lastName}` || "",
        }));
        setProgramManagers([...managers]);
      } catch (error) {
        console.error("Error fetching program managers:", error);
        setProgramManagers([]);
      }
    };
    if (!isSqeLabs) fetchProgramManagers();
  }, [isSqeLabs, accessToken]);

  useEffect(() => {
    const fetchLBA = async () => {
      try {
        const response = await getApi(
          API_GET_LEAD_BUSINESS_ANALYST_LIST,
          accessToken,
        );
        const lbas = (response.data?.data || []).map((lba) => ({
          value: lba.id,
          label: `${lba.firstName} ${lba.lastName}`,
        }));
        setLeadBusinessAnalysts(lbas);
      } catch (error) {
        console.error("Error fetching LBAs:", error);
        setLeadBusinessAnalysts([]);
      }
    };
    if (!isSqeLabs) fetchLBA();
  }, [isSqeLabs, accessToken]);

  useEffect(() => {
    const fetchHOD = async () => {
      try {
        const response = await getApi(
          API_GET_HEAD_OF_DELIVERY_LIST,
          accessToken,
        );
        const hods = (response.data?.data || []).map((hod) => ({
          value: hod.id,
          label: `${hod.firstName} ${hod.lastName}`,
        }));
        setHeadOfDeliveryList(hods);
      } catch (error) {
        console.error("Error fetching HODs:", error);
        setHeadOfDeliveryList([]);
      }
    };
    if (!isSqeLabs) fetchHOD();
  }, [isSqeLabs, accessToken]);

  useEffect(() => {
    const fetchProjectManagers = async () => {
      try {
        const response = await getApi(
          API_GET_PROJECT_MANAGER_LIST,
          accessToken,
        );

        const managers = (response.data?.data || []).map((pm) => ({
          value: pm.id,
          label: `${pm.firstName} ${pm.lastName}` || "",
        }));

        setProjectManagers([...managers]);
      } catch (error) {
        console.error("Error fetching project managers:", error);
        setProjectManagers([]);
      } finally {
      }
    };

    if (!isSqeLabs) fetchProjectManagers();
  }, [isSqeLabs, accessToken]);

  useEffect(() => {
    const fetchPrincipalSponsors = async () => {
      try {
        const response = await getApi(
          API_GET_PRINCIPAL_SPONSOR_LIST,
          accessToken,
        );

        const sponsors = (response.data?.data || []).map((sponsor) => ({
          value: sponsor.id,
          label:
            `${sponsor.firstName} ${sponsor.lastName}` || "Unnamed Sponsor",
        }));

        setPrincipalSponsors([...sponsors]);
      } catch (error) {
        console.error("Error fetching principal sponsors:", error);
        setPrincipalSponsors([]);
      }
    };

    if (!isSqeLabs) fetchPrincipalSponsors();
  }, [isSqeLabs, accessToken]);

  useEffect(() => {
    const fetchDeliveryLeads = async () => {
      try {
        const response = await getApi(API_LEAVE_GET_OOD_DL_LIST, accessToken);

        const leads = Array.isArray(response.data)
          ? response.data
          : response.data?.data || [];

        setDeliveryLead([
          ...leads.map((lead) => ({
            value: lead.id,
            label: lead.fullName || "",
          })),
        ]);
      } catch (error) {
        console.error("Error fetching delivery leads:", error);
        setDeliveryLead([]);
      }
    };

    if (!isSqeLabs) fetchDeliveryLeads();
  }, [isSqeLabs, accessToken]);

  useEffect(() => {
    if (!isSqeLabs) return;

    let active = true;
    const fetchSqeProjectLeadMembers = async () => {
      try {
        const response = await getApi(API_SQE_PROJECT_LEAD_MEMBERS, accessToken);
        if (!active) return;
        const members = getSqeProjectLeadOptions(response);
        setDeliveryLead(members);
        setProgramManagers(members);
        setPrincipalSponsors(members);
        setLeadBusinessAnalysts(members);
        setHeadOfDeliveryList(members);

        if (members.length === 1) {
          const member = members[0];
          setFormData((previous) => ({
            ...previous,
            dlId: previous.dlId || member.value,
            dlName: previous.dlName || member.label,
            programManager: previous.programManager || member.value,
            principalSponsor: previous.principalSponsor || member.value,
            leadBusinessAnalyst: previous.leadBusinessAnalyst || member.value,
            headOfDelivery: previous.headOfDelivery || member.value,
          }));
        }
      } catch (error) {
        console.error("Error fetching SQE project lead members:", error);
        if (!active) return;
        setDeliveryLead([]);
        setProgramManagers([]);
        setPrincipalSponsors([]);
        setLeadBusinessAnalysts([]);
        setHeadOfDeliveryList([]);
        toast.error("Unable to load SQE project lead members.", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    };

    fetchSqeProjectLeadMembers();
    return () => { active = false; };
  }, [isSqeLabs, accessToken]);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const response = await getApi(EMPLOYEE_LIST, accessToken);
        const employees = (response.data?.data || []).map((e) => ({
          value: e.id,
          label: e.empName || "Unnamed Employee",
        }));
        setEmployeeList([...employees]);
      } catch (error) {
        console.error("Error fetching employees:", error);
      } finally {
      }
    };
    fetchEmployees();
  }, []);

  const handleInputChange = (name, value) => {
    if (
      name === "sowStartDate" ||
      name === "sowEndDate" ||
      name === "startDate" ||
      name === "endDate"
    ) {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      if (!formData.headOfDelivery) {
        toast.error("Head of Delivery is required.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setIsLoading(false);
        return;
      }

      if (!formData.projectName.trim()) {
        toast.error("Project Name is required", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setIsLoading(false);
        return;
      }

      const isDepartmentProject = formData.timesheetAccessMode === "DEPARTMENT";

      if (!isDepartmentProject && !formData.commercialSummary.trim()) {
        toast.error("Project Description is required.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setIsLoading(false);
        return;
      }

      if (!isDepartmentProject && !formData.sowStartDate) {
        toast.error("SOW Start Date is required.", {
          position: toast.POSITION.TOP_RIGHT,
        });
        setIsLoading(false);
        return;
      }

      // SOW date validation
      if (
        formData.sowStartDate &&
        formData.sowEndDate &&
        new Date(formData.sowStartDate) > new Date(formData.sowEndDate)
      ) {
        toast.error("SOW start date cannot be after SOW end date.");
        setIsLoading(false);
        return;
      }

      // // Actual date validation
      if (
        formData.startDate &&
        formData.endDate &&
        new Date(formData.startDate) > new Date(formData.endDate)
      ) {
        toast.error("Actual start date cannot be after project end date.");
        setIsLoading(false);
        return;
      }

      const payload = isDepartmentProject ? {
        projectName: formData.projectName.trim(),
        hodLead: formData.headOfDelivery,
        timesheetAccessMode: "DEPARTMENT",
      } : {
        projectName: formData.projectName.trim(),
        projectType: formData.projectType,
        deliveryLead: parseInt(formData.dlId),
        startDate: formatToDateOnly(formData.startDate),
        endDate: formatToDateOnly(formData.endDate),
        sowStartDate: formatToDateOnly(formData.sowStartDate),
        sowEndDate: formatToDateOnly(formData.sowEndDate),
        commercialSummary: formData.commercialSummary.trim(),
        projectManager: formData.projectManager,
        programManagerId: formData.programManager,
        principalSponsor: formData.principalSponsor,
        leadBusinessAnalyst: formData.leadBusinessAnalyst,
        hodLead: formData.headOfDelivery,
        workstreams: formData.workstreams,
        needsApproval: formData.needsApproval,
        trackable: formData.trackable,
        timesheetAccessMode: formData.timesheetAccessMode,
      };

      const response = await axios.post(API_PROJECT, payload, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "application/json",
        },
      });
      toast.success(response?.data?.message, {
        position: toast.POSITION.TOP_RIGHT,
      });
      navigate("/dashboard/projectList");

      setFormData({
        projectName: "",
        projectType: "",
        dlId: "",
        dlName: "",
        startDate: "",
        endDate: "",
        sowStartDate: "",
        sowEndDate: "",
        commercialSummary: "",
        projectManager: "",
        programManager: "",
        principalSponsor: "",
        leadBusinessAnalyst: "",
        headOfDelivery: "",
        needsApproval: false,
        trackable: false,
        timesheetAccessMode: "ASSIGNED_ONLY",
        workstreams: [],
      });
    } catch (error) {
      if (error.response) {
        const errorMessage =
          error.response.data?.message ||
          error.response.data?.error ||
          `Server error: ${error.response.status}`;
        toast.error(` ${errorMessage}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else if (error.request) {
        toast.error("Failed to submit project: No response from server", {
          position: toast.POSITION.TOP_RIGHT,
        });
      } else {
        toast.error(` ${error.message}`, {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const closeProjectModeModal = () => {
    if (hasChosenProjectMode) {
      setPendingProjectMode(formData.timesheetAccessMode);
      setShowProjectModeModal(false);
      return;
    }
    navigate("/dashboard/projectList");
  };

  const confirmProjectMode = () => {
    setFormData((previous) => ({
      ...previous,
      timesheetAccessMode: pendingProjectMode,
    }));
    setHasChosenProjectMode(true);
    setShowProjectModeModal(false);
  };

  const openProjectModeModal = () => {
    setPendingProjectMode(formData.timesheetAccessMode);
    setShowProjectModeModal(true);
  };

  const projectModeModal = (
    <ProjectModeModal
      show={showProjectModeModal}
      isSqeLabs={isSqeLabs}
      value={pendingProjectMode}
      onChange={setPendingProjectMode}
      onCancel={closeProjectModeModal}
      onContinue={confirmProjectMode}
    />
  );

  if (formData.timesheetAccessMode === "DEPARTMENT") {
    return (
      <>
        {projectModeModal}
        <div className="page-heading mb-0">
          <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
            <span></span><span></span><span></span>
          </div>
        </div>
        <form id="create-project" onSubmit={handleSubmit}>
          <div className="px-4">
            <SelectedProjectMode
              value={formData.timesheetAccessMode}
              onChange={openProjectModeModal}
            />
            <div className="inputs department-project-form mt-4">
              <div className="department-project-form__heading">
                <span className="department-project-form__heading-icon">
                  <FiFileText />
                </span>
                <div>
                  <h3>Basic Information</h3>
                  <p>Provide the key details required to create this project.</p>
                </div>
              </div>
              <div className="department-project-form__content">
                <div className="department-project-form__fields">
                  <div>
                    <FormFieldRow id="projectName" label="Project Name" required>
                      <input
                        type="text"
                        id="projectName"
                        className="form-control"
                        placeholder="Enter project name"
                        value={formData.projectName}
                        maxLength={50}
                        onChange={(event) =>
                          setFormData((previous) => ({
                            ...previous,
                            projectName: capitalizeWords(event.target.value.replace(/^\s+/, "")),
                          }))
                        }
                        required
                      />
                    </FormFieldRow>
                  </div>
                  <div>
                    <FormFieldRow id="headOfDelivery" label="Head of Delivery" required>
                      <SqeMemberField isSqeLabs={isSqeLabs} options={headOfDeliveryList} inputId="headOfDelivery">
                      <Select
                        {...SELECT_PROPS}
                        inputId="headOfDelivery"
                        options={headOfDeliveryList}
                        value={headOfDeliveryList.find((item) => item.value === formData.headOfDelivery) || null}
                        onChange={(option) =>
                          setFormData((previous) => ({
                            ...previous,
                            headOfDelivery: option?.value || "",
                          }))
                        }
                        placeholder="Select Head of Delivery"
                        isClearable
                        menuPosition="fixed"
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: (base) => ({ ...base, zIndex: 4000 }),
                        }}
                        required
                      />
                      </SqeMemberField>
                    </FormFieldRow>
                  </div>
                </div>
                <div className="department-project-form__access">
                  <div className="department-project-form__access-title">
                    <span><FiUsers /></span>
                    <div>
                      <strong>Employee Access</strong>
                      <small>Controlled separately after creation</small>
                    </div>
                  </div>
                  <div className="department-project-form__note">
                    <FiInfo />
                    <div>
                      <strong>Only explicitly assigned employees get access</strong>
                      <span>Department and designation are taken from each employee's current profile. Employees from different departments can be added to the same project.</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="department-project-form__actions">
                <Link to="/dashboard/projectList" className="brand-color">
                  <button type="button" className="project-mode-cancel">Cancel</button>
                </Link>
                <button className="project-mode-continue" type="submit" disabled={isLoading}>
                  {isLoading ? <ThreeDots height="22" width="54" radius="9" color="white" /> : "Create Project"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </>
    );
  }

  return (
    <>
      {projectModeModal}
      <div className="page-heading mb-0">
        <div id="showMenuBtn" className="collapse-button" onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>

      <form id="create-project" onSubmit={handleSubmit}>
        <div className="px-4">
          <SelectedProjectMode
            value={formData.timesheetAccessMode}
            onChange={openProjectModeModal}
          />
          <div className="inputs">
            <div className="cp-layout">
              <div className="cp-col">
                <FormFieldRow id="projectName" label="Project Name" required>
                  <div className="input-group">
                    <input
                      type="text"
                      id="projectName"
                      name="projectName"
                      value={formData.projectName}
                      onChange={(e) => {
                        let value = e.target.value;
                        if (value.startsWith(" ")) {
                          return;
                        }
                        value = value.replace(/\s{3,}/g, "  ");
                        if (/^\d+$/.test(value)) {
                          return;
                        }
                        const hasAlphabet = /[a-zA-Z]/.test(value);

                        if (hasAlphabet) {
                          const specialCount = (
                            value.match(/[^a-zA-Z0-9 ]/g) || []
                          ).length;

                          if (specialCount > 5) {
                            return;
                          }
                        } else {
                          value = value.replace(/[^a-zA-Z0-9 ]/g, "");
                        }

                        value = capitalizeWords(value);

                        setFormData((prev) => ({
                          ...prev,
                          projectName: value,
                        }));
                      }}
                      maxLength={50}
                      required
                    />
                  </div>
                </FormFieldRow>

                <FormFieldRow id="projectType" label="Project Type" required>
                  <Select
                    {...SELECT_PROPS}
                    inputId="projectType"
                    name="projectType"
                    placeholder="Select Project Type"
                    options={projectTypeOptions}
                    value={
                      projectTypeOptions.find(
                        (option) => option.value === formData.projectType,
                      ) || null
                    }
                    onChange={(selectedOption) =>
                      setFormData((prev) => ({
                        ...prev,
                        projectType: selectedOption?.value || "",
                      }))
                    }
                    isClearable
                    required
                  />
                </FormFieldRow>

                <FormFieldRow id="dlId" label="Delivery Lead" required>
                  <SqeMemberField isSqeLabs={isSqeLabs} options={deliveryLead} inputId="dlId">
                  <Select
                    {...SELECT_PROPS}
                    inputId="dlId"
                    name="dlId"
                    value={
                      deliveryLead.find((lead) => lead.value === formData.dlId) ||
                      null
                    }
                    onChange={(selectedOption) => {
                      setFormData((prev) => ({
                        ...prev,
                        dlId: selectedOption?.value || "",
                        dlName: selectedOption?.label || "",
                      }));
                    }}
                    options={deliveryLead}
                    placeholder="Select Delivery Lead"
                    required
                    isClearable
                  />
                  </SqeMemberField>
                </FormFieldRow>

                <FormFieldRow id="projectManager" label="Project Manager" required>
                  <Select
                    {...SELECT_PROPS}
                    inputId="projectManager"
                    name="projectManager"
                    placeholder="Select Project Manager"
                    options={selectableProjectManagers}
                    value={
                      selectableProjectManagers.find(
                        (e) => e.value === formData.projectManager,
                      ) || null
                    }
                    onChange={(selectedOption) =>
                      setFormData((prev) => ({
                        ...prev,
                        projectManager: selectedOption?.value || "",
                      }))
                    }
                    isClearable
                    required
                  />
                </FormFieldRow>

                <FormFieldRow id="programManager" label="Program Manager">
                  <SqeMemberField isSqeLabs={isSqeLabs} options={programManagers} inputId="programManager">
                  <Select
                    {...SELECT_PROPS}
                    inputId="programManager"
                    name="programManager"
                    placeholder="Select Program Manager"
                    options={programManagers}
                    value={
                      programManagers.find(
                        (e) => e.value === formData.programManager,
                      ) || null
                    }
                    onChange={(selectedOption) =>
                      setFormData((prev) => ({
                        ...prev,
                        programManager: selectedOption?.value || "",
                      }))
                    }
                    isClearable
                  />
                  </SqeMemberField>
                </FormFieldRow>

                <FormFieldRow
                  id="principalSponsor"
                  label="Principal Sponsor"
                  required
                >
                  <SqeMemberField isSqeLabs={isSqeLabs} options={principalSponsors} inputId="principalSponsor">
                  <Select
                    {...SELECT_PROPS}
                    inputId="principalSponsor"
                    name="principalSponsor"
                    placeholder="Select Principal Sponsor"
                    options={principalSponsors}
                    value={
                      principalSponsors.find(
                        (e) => e.value === formData.principalSponsor,
                      ) || null
                    }
                    onChange={(selectedOption) =>
                      setFormData((prev) => ({
                        ...prev,
                        principalSponsor: selectedOption?.value || "",
                      }))
                    }
                    isClearable
                    required
                  />
                  </SqeMemberField>
                </FormFieldRow>

                <FormFieldRow
                  id="leadBusinessAnalyst"
                  label="Lead Business Analyst"
                >
                  <SqeMemberField isSqeLabs={isSqeLabs} options={leadBusinessAnalysts} inputId="leadBusinessAnalyst">
                  <Select
                    {...SELECT_PROPS}
                    inputId="leadBusinessAnalyst"
                    name="leadBusinessAnalyst"
                    placeholder="Select Lead Business Analyst"
                    options={leadBusinessAnalysts}
                    value={
                      leadBusinessAnalysts.find(
                        (e) => e.value === formData.leadBusinessAnalyst,
                      ) || null
                    }
                    onChange={(selectedOption) =>
                      setFormData((prev) => ({
                        ...prev,
                        leadBusinessAnalyst: selectedOption?.value || "",
                      }))
                    }
                    isClearable
                  />
                  </SqeMemberField>
                </FormFieldRow>

                <FormFieldRow
                  id="headOfDelivery"
                  label="Head of Delivery"
                  required
                >
                  <SqeMemberField isSqeLabs={isSqeLabs} options={headOfDeliveryList} inputId="headOfDelivery">
                  <Select
                    {...SELECT_PROPS}
                    inputId="headOfDelivery"
                    name="headOfDelivery"
                    placeholder="Select Head of Delivery"
                    options={headOfDeliveryList}
                    value={
                      headOfDeliveryList.find(
                        (e) => e.value === formData.headOfDelivery,
                      ) || null
                    }
                    onChange={(selectedOption) =>
                      setFormData((prev) => ({
                        ...prev,
                        headOfDelivery: selectedOption?.value || "",
                      }))
                    }
                    isClearable
                    required
                  />
                  </SqeMemberField>
                </FormFieldRow>

                <FormFieldRow id="sowStartDate" label="SOW" align="start">
                  <DateRangeInputs
                    startDate={formData.sowStartDate}
                    endDate={formData.sowEndDate}
                    onStartChange={(date) =>
                      handleInputChange("sowStartDate", date)
                    }
                    onEndChange={(date) => handleInputChange("sowEndDate", date)}
                    startRequired
                    endMinDate={formData.sowStartDate}
                  />
                </FormFieldRow>

                <FormFieldRow id="startDate" label="Actual" align="start">
                  <DateRangeInputs
                    startDate={formData.startDate}
                    endDate={formData.endDate}
                    onStartChange={(date) => handleInputChange("startDate", date)}
                    onEndChange={(date) => handleInputChange("endDate", date)}
                    endMinDate={formData.startDate}
                    startMaxDate={
                      formData.sowEndDate ? new Date(formData.sowEndDate) : null
                    }
                  />
                </FormFieldRow>
              </div>

              <div className="cp-col">
                <FormFieldRow id="needsApproval" label="Need Approval" required>
                  <Select
                    {...SELECT_PROPS}
                    inputId="needsApproval"
                    name="needsApproval"
                    placeholder="Select Need Approval"
                    options={needsApprovalOptions}
                    value={
                      needsApprovalOptions.find(
                        (option) => option.value === formData.needsApproval,
                      ) || needsApprovalOptions[1]
                    }
                    onChange={(selectedOption) =>
                      setFormData((prev) => ({
                        ...prev,
                        needsApproval: selectedOption?.value ?? false,
                      }))
                    }
                    isClearable={false}
                  />
                </FormFieldRow>

                <FormFieldRow id="trackable" label="Trackable" required>
                  <Select
                    {...SELECT_PROPS}
                    inputId="trackable"
                    name="trackable"
                    placeholder="Select Trackable"
                    options={trackableOptions}
                    value={
                      trackableOptions.find(
                        (option) => option.value === formData.trackable,
                      ) || trackableOptions[1]
                    }
                    onChange={(selectedOption) =>
                      setFormData((prev) => ({
                        ...prev,
                        trackable: selectedOption?.value ?? false,
                      }))
                    }
                    isClearable={false}
                  />
                </FormFieldRow>

                <FormDescriptionField>
                  <CharLimitTextArea
                    id="commercialSummary"
                    name="commercialSummary"
                    required
                    rows={17}
                    placeholder="Type Here"
                    maxLength={1500}
                    value={formData.commercialSummary}
                    onChange={(e) =>
                      handleInputChange(e.target.name, e.target.value)
                    }
                    lengthParam={formData.commercialSummary?.length || 0}
                  />
                </FormDescriptionField>
              </div>
            </div>
          </div>
          <br />

          <div className="action text-center ">
            <button
              className="btn theme-button px-4"
              type="submit"
              disabled={isLoading}
            >
              {isLoading ? (
                <ThreeDots
                  height="22"
                  width="60"
                  radius="9"
                  color="white"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={true}
                />
              ) : (
                " Submit "
              )}
            </button>

            <Link to="/dashboard/projectList" className="brand-color">
              <button type="button" className="theme-button ms-3 px-4 bg-grey">
                Cancel
              </button>
            </Link>

            <a
              data-bs-toggle="modal"
              data-bs-target="#staticBackdropAsset"
              className="open-modal visually-hidden"
            >
              click
            </a>
          </div>
        </div>
      </form>
    </>
  );
};

export default CreateProject;
